import * as React from 'react';
import { FC } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { DropdownButton, NavLink } from 'react-bootstrap';
import { getAuth } from 'firebase/auth';
import type { YoAuthUser } from '@yakoffice/yakoffice-firebase';
import styles from './yo-user-menu.module.sass';

export interface YoUserMenuProps {
    authUser: YoAuthUser;
    hostedInPortal: boolean;
    portalUrl: string;
    portalUsersRoute: string;
}

export const YoUserMenu: FC<YoUserMenuProps> = (props) => {

    const userIcon = () => {

        if (props.authUser && props.authUser.firebaseUser.photoURL)
            return <img className={styles.userIcon} src={props.authUser.firebaseUser.photoURL} alt={''} />;

        if (props.authUser && props.authUser.firebaseUser.displayName)
            return <div
                className={styles.userIcon}>{props.authUser.firebaseUser.displayName.slice(0, 1).toLocaleUpperCase()}</div>;

        else
            return <><i className="far fa-user" />Guest</>;
    };

    const adjustRoute = (route: string) => {
        return props.hostedInPortal ? route : (props.portalUrl + route);
    };

    return (
        <DropdownButton
            className={`${styles.userMenu}`}
            variant="secondary"
            title={userIcon()}>
            {props.authUser.firebaseUser && <>
                <Dropdown.ItemText className="text-center fs-6 fw-semibold mb-0 pb-0">
                    <div style={{
                        display: 'block'
                    }}>{props.authUser.firebaseUser.email}</div>
                </Dropdown.ItemText>
                <Dropdown.ItemText className="text-center mb-2 mt-0 pt-0">
                    <NavLink href="https://support.google.com/accounts/answer/181692" target={'_blank'}>
                        <small>Managed by miniclip.com</small>
                    </NavLink>
                </Dropdown.ItemText>

                <Dropdown.ItemText className="text-center">
                </Dropdown.ItemText>
                {userIcon()}
                <Dropdown.ItemText
                    className="text-center fs-4 mb-3">Hi, {props.authUser.firebaseUser.displayName?.split(' ')[0]}!</Dropdown.ItemText>
            </>
            }
            <div className={styles.innerUserMenu}>
                {props.authUser.yoUser?.isAdmin &&
                    <>
                        <Dropdown.Item as="button">
                            <NavLink href={adjustRoute(props.portalUsersRoute)}>
                                <i className="fas fa-user-tie" /> Manage users
                            </NavLink>
                        </Dropdown.Item>
                        <Dropdown.Divider />
                    </>
                }
                <Dropdown.Item as="button">
                    <NavLink href={'https://confluence.cf.miniclip.com/display/YAK/YakOffice'} target={'_blank'}>
                        <i className="fas fa-question" /> Help
                    </NavLink>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item as="button">
                    <NavLink href={props.portalUrl} onClick={() => getAuth().signOut()}>
                        <i className="fas fa-sign-out-alt" /> Logout
                    </NavLink>
                </Dropdown.Item>
            </div>
            <Dropdown.ItemText className="text-center mt-2">
                <small style={{
                    display: 'block',
                    fontSize: '12px'
                }}>YakOffice: {process.env.REACT_APP_GIT_BRANCH ? process.env.REACT_APP_GIT_BRANCH : '2.0.0'}</small>
            </Dropdown.ItemText>
        </DropdownButton>
    );
};
